
import { useState } from 'react';

export default function Camps() {
  const [selectedCamp, setSelectedCamp] = useState('all');

  const campCourses = [
    {
      id: 1,
      title: "寒假寫作冬令營",
      season: "冬令營",
      campType: "winter",
      duration: "3小時/日",
      students: "4-6人小班",
      price: "5日一梯次",
      schedule: "1/20-1/24, 2/3-2/7",
      features: ["密集式教學", "主題創作", "作品發表", "同儕互動", "創意啟發", "成果展示"],
      description: "寒假期間特別規劃的5日密集寫作營隊，透過多元主題引導孩子發揮創意，在短時間內大幅提升寫作能力，營造濃厚的學習氛圍。每日3小時的密集訓練，讓孩子在假期中也能持續學習成長。",
      highlights: ["5日密集訓練", "多元主題創作", "早鳥優惠價"],
      dailySchedule: [
        { day: "第一日", theme: "自我介紹與創意發想", content: "破冰活動、寫作興趣探索" },
        { day: "第二日", theme: "故事創作技巧", content: "角色設定、情節發展" },
        { day: "第三日", theme: "描寫技巧訓練", content: "人物描寫、場景描述" },
        { day: "第四日", theme: "議論文寫作", content: "觀點表達、論證技巧" },
        { day: "第五日", theme: "作品發表與回饋", content: "成果展示、同儕互評" }
      ],
      image: "https://public.readdy.ai/ai/img_res/77e338cb12baec7bb42e2d9e18911f4c.jpg"
    },
    {
      id: 2,
      title: "暑假寫作夏令營",
      season: "夏令營",
      campType: "summer",
      duration: "3小時/日",
      students: "4-6人小班",
      price: "10日兩梯次",
      schedule: "7/1-7/12, 8/5-8/16",
      features: ["長期培養", "進階寫作", "文學賞析", "創意思維", "表達訓練", "作品集製作"],
      description: "暑假期間的長期寫作營隊，分為兩個梯次進行，讓孩子在輕鬆的暑假氛圍中持續精進寫作技巧，培養深度思考能力。完整的10日課程設計，從基礎到進階全面提升。",
      highlights: ["10日完整訓練", "作品集製作", "暑期特惠"],
      dailySchedule: [
        { day: "第1-2日", theme: "寫作基礎建立", content: "文體認識、基本技巧" },
        { day: "第3-4日", theme: "記敘文精進", content: "敘事技巧、情感表達" },
        { day: "第5-6日", theme: "說明文訓練", content: "邏輯思維、條理表達" },
        { day: "第7-8日", theme: "議論文進階", content: "論證方法、批判思考" },
        { day: "第9-10日", theme: "創意寫作與發表", content: "自由創作、作品集製作" }
      ],
      image: "https://readdy.ai/api/search-image?query=Taiwanese%20children%20with%20East%20Asian%20features%20in%20summer%20writing%20camp%20online%20class.%20The%20scene%20shows%20happy%20kids%20aged%208-15%20with%20typical%20Taiwanese%20facial%20features%20using%20computers%20and%20tablets%20for%20creative%20writing%20during%20summer%20vacation.%20Bright%20sunny%20atmosphere%20with%20summer%20elements%2C%20plants%2C%20and%20cheerful%20home%20learning%20environment.%20Pink%20and%20white%20color%20scheme%20with%20natural%20lighting%20creating%20an%20energetic%20and%20inspiring%20online%20summer%20learning%20experience%20for%20Taiwanese%20students.&width=600&height=400&seq=taiwan-summer-camp-detail&orientation=landscape"
    },
    {
      id: 3,
      title: "客製化學習",
      season: "春令營",
      campType: "spring",
      duration: "2小時/日",
      students: "4-6人小班",
      price: "3日一梯次",
      schedule: "3/25-3/27, 4/1-4/3",
      features: ["短期集中", "基礎強化", "技巧提升", "快速見效", "彈性安排", "個別指導"],
      description: "春季期間的短期寫作營隊，適合想要快速提升寫作技巧的學生，在短時間內針對特定寫作技巧進行密集訓練。彈性的時間安排，不影響正常課業。",
      highlights: ["3日快速提升", "技巧專精", "彈性時間"],
      dailySchedule: [
        { day: "第一日", theme: "寫作技巧診斷", content: "個人寫作能力評估、弱點分析" },
        { day: "第二日", theme: "重點技巧強化", content: "針對性訓練、實作練習" },
        { day: "第三日", theme: "成果驗收", content: "技巧應用、成效檢視" }
      ],
      image: "https://readdy.ai/api/search-image?query=Taiwanese%20children%20with%20East%20Asian%20features%20in%20spring%20writing%20workshop%20online%20class.%20The%20scene%20shows%20focused%20kids%20aged%208-15%20with%20typical%20Taiwanese%20facial%20features%20using%20digital%20devices%20for%20writing%20practice%20during%20spring%20season.%20Fresh%20spring%20atmosphere%20with%20flowers%20and%20green%20plants%20in%20background%2C%20cozy%20home%20learning%20setup.%20Pink%20and%20white%20color%20scheme%20with%20soft%20natural%20lighting%20creating%20a%20peaceful%20and%20productive%20online%20learning%20environment%20for%20Taiwanese%20students.&width=600&height=400&seq=taiwan-spring-camp-detail&orientation=landscape"
    }
  ];

  const campTypes = [
    { id: 'all', label: '全部營隊', icon: 'ri-calendar-line' },
    { id: 'winter', label: '寒假冬令營', icon: 'ri-snowflake-line' },
    { id: 'summer', label: '暑假夏令營', icon: 'ri-sun-line' },
    { id: 'spring', label: '春季短期營', icon: 'ri-leaf-line' }
  ];

  const filteredCamps = selectedCamp === 'all' 
    ? campCourses 
    : campCourses.filter(camp => camp.campType === selectedCamp);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b border-pink-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-pink-500" style={{fontFamily: '"Pacifico", serif'}}>
                共學趣
              </h1>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <a href="/" className="text-gray-700 hover:text-pink-500 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors">首頁</a>
                <a href="/courses" className="text-gray-700 hover:text-pink-500 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors">課程介紹</a>
                <a href="/camps" className="text-pink-500 font-medium px-3 py-2 rounded-md text-sm whitespace-nowrap cursor-pointer bg-pink-50 rounded-full">冬夏令營</a>
                <a href="/teachers" className="text-gray-700 hover:text-pink-500 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors">師資團隊</a>
                <a href="/results" className="text-gray-700 hover:text-pink-500 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors">教學成果</a>
                <a href="/trial" className="text-gray-700 hover:text-pink-500 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors">免費試聽</a>
              </div>
            </div>
            <div className="md:hidden">
              <button className="text-gray-700 hover:text-pink-500 w-6 h-6 flex items-center justify-center cursor-pointer">
                <i className="ri-menu-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-orange-50 via-pink-50 to-rose-50 py-24">
        <div className="absolute inset-0 bg-white/30"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center gap-2 bg-orange-500/10 text-orange-600 px-4 py-2 rounded-full text-sm font-medium mb-6">
            <i className="ri-fire-fill text-orange-500"></i>
            <span>假期專屬營隊</span>
          </div>
          <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 mb-6">
            冬夏令營
            <span className="text-orange-500 block lg:inline lg:ml-4">寫作營隊</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8 leading-relaxed">
            假期期間的密集寫作訓練營隊，透過主題式教學與同儕互動<br/>
            在短時間內大幅提升孩子的寫作能力與創意思維
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="/trial" className="bg-orange-500 text-white px-8 py-4 rounded-full font-semibold hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer shadow-lg">
              立即報名營隊
            </a>
            <button className="border-2 border-orange-500 text-orange-500 px-8 py-4 rounded-full font-semibold hover:bg-orange-500 hover:text-white transition-colors whitespace-nowrap cursor-pointer">
              查看營隊時間
            </button>
          </div>
        </div>
      </section>

      {/* Camp Filter */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              營隊課程選擇
            </h2>
            <p className="text-lg text-gray-600">
              根據假期時間和學習需求選擇最適合的營隊
            </p>
          </div>
          
          <div className="flex justify-center mb-16">
            <div className="bg-gray-50 rounded-2xl p-2 flex gap-2 flex-wrap justify-center">
              {campTypes.map((type) => (
                <button
                  key={type.id}
                  onClick={() => setSelectedCamp(type.id)}
                  className={`px-6 py-4 rounded-xl font-medium transition-all whitespace-nowrap cursor-pointer flex items-center gap-2 ${
                    selectedCamp === type.id
                      ? 'bg-orange-500 text-white shadow-lg transform scale-105'
                      : 'text-gray-600 hover:bg-white hover:shadow-md'
                  }`}
                >
                  <i className={type.icon}></i>
                  {type.label}
                </button>
              ))}
            </div>
          </div>

          {/* Camps Grid */}
          <div className="grid lg:grid-cols-1 gap-12">
            {filteredCamps.map((camp) => (
              <div key={camp.id} className="bg-white rounded-3xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 border border-gray-100">
                <div className="grid lg:grid-cols-2 gap-0">
                  {/* Image Section */}
                  <div className="relative h-80 lg:h-auto">
                    <img 
                      src={camp.image}
                      alt={camp.title}
                      className="w-full h-full object-cover object-top"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                    <div className="absolute top-4 left-4 bg-orange-500 text-white px-4 py-2 rounded-full text-sm font-medium shadow-lg">
                      {camp.season}
                    </div>
                    <div className="absolute bottom-4 left-4 flex gap-2">
                      {camp.highlights.map((highlight, index) => (
                        <span key={index} className="bg-white/90 text-gray-800 px-3 py-1 rounded-full text-xs font-medium">
                          {highlight}
                        </span>
                      ))}
                    </div>
                  </div>
                  
                  {/* Content Section */}
                  <div className="p-8 lg:p-12">
                    <div className="flex items-start justify-between mb-6">
                      <h3 className="text-3xl font-bold text-gray-900">{camp.title}</h3>
                      <div className="text-right">
                        <div className="text-xl font-bold text-orange-500">{camp.price}</div>
                        <div className="text-sm text-gray-500">{camp.schedule}</div>
                      </div>
                    </div>
                    
                    <p className="text-gray-600 mb-8 leading-relaxed text-lg">{camp.description}</p>
                    
                    <div className="grid grid-cols-2 gap-6 mb-8">
                      <div className="flex items-center gap-3 p-4 bg-orange-50 rounded-xl">
                        <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center">
                          <i className="ri-time-line text-orange-500 text-xl"></i>
                        </div>
                        <div>
                          <p className="text-sm text-gray-500">課程時長</p>
                          <p className="font-semibold text-gray-800">{camp.duration}</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-3 p-4 bg-blue-50 rounded-xl">
                        <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                          <i className="ri-group-line text-blue-500 text-xl"></i>
                        </div>
                        <div>
                          <p className="text-sm text-gray-500">班級人數</p>
                          <p className="font-semibold text-gray-800">{camp.students}</p>
                        </div>
                      </div>
                    </div>

                    <div className="mb-8">
                      <h4 className="font-semibold text-gray-900 mb-4 flex items-center gap-2 text-lg">
                        <i className="ri-star-line text-orange-500"></i>
                        營隊特色
                      </h4>
                      <div className="grid grid-cols-2 gap-3">
                        {camp.features.map((feature, index) => (
                          <div key={index} className="flex items-center gap-2 py-2">
                            <i className="ri-check-line text-green-500"></i>
                            <span className="text-gray-600">{feature}</span>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="mb-8">
                      <h4 className="font-semibold text-gray-900 mb-4 flex items-center gap-2 text-lg">
                        <i className="ri-calendar-check-line text-orange-500"></i>
                        課程安排
                      </h4>
                      <div className="space-y-3">
                        {camp.dailySchedule.map((schedule, index) => (
                          <div key={index} className="flex gap-4 p-3 bg-gray-50 rounded-lg">
                            <div className="w-20 text-sm font-medium text-orange-600 flex-shrink-0">
                              {schedule.day}
                            </div>
                            <div className="flex-1">
                              <div className="font-medium text-gray-900 mb-1">{schedule.theme}</div>
                              <div className="text-sm text-gray-600">{schedule.content}</div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="flex gap-4">
                      <a href="/trial" className="flex-1 bg-orange-500 text-white py-4 rounded-xl font-semibold hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer text-center">
                        立即報名
                      </a>
                      <a href="/trial" className="flex-1 border-2 border-orange-500 text-orange-500 py-4 rounded-xl font-semibold hover:bg-orange-50 transition-colors whitespace-nowrap cursor-pointer text-center">
                        諮詢詳情
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-orange-500 via-pink-500 to-rose-500 relative overflow-hidden">
        <div className="absolute inset-0 bg-black/10"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
            準備好加入我們的營隊了嗎？
          </h2>
          <p className="text-xl text-orange-100 mb-8 max-w-2xl mx-auto leading-relaxed">
            名額有限，早鳥優惠進行中！<br/>
            立即報名，讓孩子在假期中也能持續成長
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="/trial" className="bg-white text-orange-500 px-8 py-4 rounded-full font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer shadow-lg">
              立即報名營隊
            </a>
            <button className="border-2 border-white text-white px-8 py-4 rounded-full font-semibold hover:bg-white hover:text-orange-500 transition-colors whitespace-nowrap cursor-pointer">
              了解更多詳情
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div className="md:col-span-2">
              <h3 className="text-2xl font-bold mb-4 text-pink-400" style={{fontFamily: '"Pacifico", serif'}}>
                共學趣
              </h3>
              <p className="text-gray-400 mb-6 leading-relaxed">
                專業線上寫作教室，致力於培養孩子的寫作能力與創意思維。
                我們相信每個孩子都有無限潛能，只需要正確的引導。
              </p>
              <div className="flex gap-4">
                <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-pink-500 transition-colors cursor-pointer">
                  <i className="ri-line-fill text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-pink-500 transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-pink-500 transition-colors cursor-pointer">
                  <i className="ri-instagram-fill text-lg"></i>
                </a>
              </div>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">快速連結</h4>
              <ul className="space-y-2">
                <li><a href="/courses" className="text-gray-400 hover:text-white transition-colors cursor-pointer">課程介紹</a></li>
                <li><a href="/camps" className="text-gray-400 hover:text-white transition-colors cursor-pointer">冬夏令營</a></li>
                <li><a href="/teachers" className="text-gray-400 hover:text-white transition-colors cursor-pointer">師資團隊</a></li>
                <li><a href="/results" className="text-gray-400 hover:text-white transition-colors cursor-pointer">教學成果</a></li>
                <li><a href="/trial" className="text-gray-400 hover:text-white transition-colors cursor-pointer">免費試聽</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">聯絡資訊</h4>
              <ul className="space-y-2 text-gray-400">
                <li className="flex items-center gap-2">
                  <i className="ri-line-fill"></i>
                  <span>@write123</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-time-fill"></i>
                  <span>週一至週日 9:00-21:00</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-global-fill"></i>
                  <span>線上教學，不限地區</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2025 共學趣線上寫作教室. All rights reserved. | 
              <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors cursor-pointer ml-2">Powered by Readdy</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}